import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { viewGet } from '@uncinc/react-drupal-core/dist/redux/actions/Entity/View';

import Modal from '../../containers/Modal';
import useRoutes from '../../hooks/useRoutes';
import useTypedDispatch from '../../hooks/useTypedDispatch';
import PageCreateRecoveryPlan from '../../pages/CreateRecoveryPlan';
import { reinitializeRegistrationData } from '../../store/actions/Registrations';
import {
  QuizCheckboxes,
  QuizRadios,
  RiskSituationSubmission,
  WebformTextFieldWithDelta,
  Webform,
  WebformProcessedText,
} from '../../components';

import './style.scss';

interface Props {
  root?: boolean;
  id: string;
  title: string;
}

const WebformWrapper: React.FC<Props> = ({ root, id, title }) => {
  const history = useHistory();

  const [modalVisible, setModalVisible] = useState(true);
  const { t } = useTranslation();
  const dispatch = useTypedDispatch();
  // eslint-disable-next-line
  const routes = useRoutes();

  const onCloseModal = () => {
    setModalVisible(!modalVisible);
    history.push(routes.program);
  };

  return (
    <Modal
      modalVisible={modalVisible}
      title={id === 'goal' ? t('pages.create_recovery_plan.title') : title}
      closeModal={onCloseModal}
    >
      {id === 'goal' ? (
        <PageCreateRecoveryPlan
          onSuccessfulSubmit={() => {
            dispatch(viewGet('exercise_answers', 'default', 0, null, {}));
            dispatch(reinitializeRegistrationData()).catch(() => {});

            setModalVisible(!modalVisible);
            history.push(routes.recoveryPlan);
          }}
        />
      ) : (
        <div className="WebformWrapper col-lg-8 offset-lg-2">
          <Webform
            root={root}
            id={id}
            onClose={onCloseModal}
            overriddenComponents={{
              risk_situation_submission: RiskSituationSubmission,
              quiz_checkboxes: QuizCheckboxes,
              quiz_radios: QuizRadios,
              textfield: WebformTextFieldWithDelta,
              processed_text: WebformProcessedText,
            }}
          />
        </div>
      )}
    </Modal>
  );
};

export default WebformWrapper;
